<template>
  <b-form @submit.prevent="save">
    <b-row>
      <b-col md="6" lg="4">
        <b-form-group :label="`${$t('FIRST_NAME')} *`">
          <b-form-input
            type="text"
            v-model="object.first_name"
            name="first_name">
          </b-form-input>
          <validation-description :show="$v.object.first_name.$dirty && $v.object.first_name.$invalid">
            {{$t('FIELD_MANDATORY')}}
          </validation-description>
        </b-form-group>
      </b-col>
      <b-col md="6" lg="4">
        <b-form-group :label="`${$t('LAST_NAME')} *`">
          <b-form-input
            type="text"
            v-model="object.last_name"
            name="last_name">
          </b-form-input>
          <validation-description :show="$v.object.last_name.$dirty && $v.object.last_name.$invalid">
            {{$t('FIELD_MANDATORY')}}
          </validation-description>
        </b-form-group>
      </b-col>
      <b-col md="6" lg="4">
        <b-form-group :label="$t('DATE_OF_BIRTH')">
          <date-picker :placeholder="$t('SELECT_DATE')" :value="object.date_of_birth" @change="updateDateOfBirth"></date-picker>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="6" lg="4">
        <b-form-group :label="$t('PLACE_OF_BIRTH')">
          <b-form-input
            type="text"
            v-model="object.place_of_birth"
            name="last_name">
          </b-form-input>
        </b-form-group>
      </b-col>
      <b-col md="6" lg="4">
        <b-form-group :label="`${$t('GENDER')} *`" style="height: 4rem">
          <b-select :options="genderOptions"
                    type="select"
                    v-model="object.gender"
                    name="gender">
          </b-select>
          <validation-description :show="$v.object.gender.$dirty && $v.object.gender.$invalid">
            {{$t('FIELD_MANDATORY')}}
          </validation-description>
        </b-form-group>
      </b-col>
      <b-col md="6" lg="4" style="height: 4rem">
        <b-form-group :label="`${$t('TOWN')}`">
          <b-form-input
            type="text"
            v-model="object.town">
          </b-form-input>
        </b-form-group>
      </b-col>
      <b-col md="6" lg="4" >
        <b-form-group  :label="`${$t('ECONOMY')} *`" >
          <country v-model="object.country" id="tooltip-target-16"></country>
          <validation-description :show="$v.object.country.id.$dirty && $v.object.country.id.$invalid">
            {{$t('FIELD_MANDATORY')}}
          </validation-description>
        </b-form-group>
      </b-col>
      <b-col md="6" lg="4">
        <b-form-group :label="$t('NATIONALITY')">
          <b-form-input
            type="text"
            v-model="object.nationality">
          </b-form-input>
        </b-form-group>
      </b-col>
      <b-col lg="12">
        <b-form-group :label="$t('CONTACT')">
          <b-form-textarea
            type="text"
            v-model.trim="object.contact"
            rows="1"
            name="contact">
          </b-form-textarea>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row class="mb-3">
      <b-col>
        <submit :c_permission="C_APPLICANT_SAVE_BUTTON"></submit>
      </b-col>
    </b-row>
  </b-form>
</template>

<script>
  import Country from '@/components/applicant/recognation/fields/Country'
  import Submit from '@/components/app/AppSubmit'
  import {toast} from '@/shared/plugins/toastr'
  import {getErrorMessage} from '@/mixins/error/getErrorMessage'
  import DatePicker from '@/components/app/datetime/DatePicker'
  import routeNames from '@/router/routeNames'
  import {required} from 'vuelidate/lib/validators'
  import ValidationDescription from '@/components/app/form/AppValidationDescription'
  import {createApplicant} from '@/services/applicant/index'
  import i18n from '@/locale/index'
  import {C_APPLICANT_SAVE_BUTTON} from '@/shared/component_permission'

  export default {
    name: "BasicNewForm",
    data() {
      return {
        applicantInstitution:[],
        $messageUser:'',
        object:{
          first_name:null,
          last_name:null,
          date_of_birth:null,
          place_of_birth: null,
          gender:null,
          nationality:null,
          contact:null,
          institution_id:null,
          town:null,
          country:{
            id:null,
            name:null
          }
        },

        genderOptions:[
          {value:'m', text: this.$t('MALE')},
          {value:'z', text: this.$t('FEMALE')}
        ],
        C_APPLICANT_SAVE_BUTTON
      }
    },
    mixins:[getErrorMessage],
    components:{
      Submit,
      DatePicker,
      ValidationDescription,
      Country
    },
    validations:{
      object:{
        first_name:{required},
        last_name:{required},
        gender: { required },
        country:{
          id:{required}
        }
      }
    },
    computed:{
      user(){
        return this.$store.getters['user/getUser']
      },
      institution(){
        return this.user.institution
      }
    },
    methods:{
      save(){
        this.$v.object.$touch()
        if(this.$v.object.$invalid){
       toast({
            'title': this.$t('VALIDATION_FAILED'),
            'message': null,
            'type': 'error',
            'timeout': 6000
          })
          return
        }
        this.object.institution_id = this.institution.id
        let applicant = {
          first_name: this.object.first_name,
          last_name: this.object.last_name,
          date_of_birth: this.object.date_of_birth,
          place_of_birth: this.object.place_of_birth,
          gender: this.object.gender,
          nationality: this.object.nationality,
          contact: this.object.contact,
          institution_id: this.object.institution_id,
          town: this.object.town,
          country: this.object.country.id
        }
        this.$store.dispatch('applicant/actionCreateApplicant',applicant)
          .then(response => {
            if(response.data.ad_institution_list){
              for(let institution of response.data.ad_institution_list) {
                this.applicantInstitution.push(institution.name)
              }
              this.$toast.info(this.$t('APPLICANT_WARNING',{first_name:response.data.first_name, last_name:response.data.last_name, institution:this.applicantInstitution}), {
                  position: "top-right",
                  timeout: false,
                  closeOnClick: true,
                  pauseOnFocusLoss: true,
                  hideCloseButton: false,
                  icon: true,
              });
              toast({
                'title': this.$t('NOTIFICATIONS.SAVE_SUCCESS.MESSAGE'),
                'type': 'success',
                'timeout': 2000
              })

            }else{
              toast({
                'title': this.$t('NOTIFICATIONS.SAVE_SUCCESS.MESSAGE'),
                'type': 'success',
                'timeout': 2000
              })
            }
            this.goTo(response.data.id)
            }, error => {
              toast({
                'title': "Save  fail",
                'message': this.getMessages(error),
                'type': 'error',
                'timeout': 6000
              })
            }
          )
      },
      updateDateOfBirth(value) {
        this.object.date_of_birth = value
      },
      goTo(id){
        this.$router.push({name: routeNames.RN_APPLICANT_BASIC, params: {id: id}})
      }
    }
  }
</script>

<style scoped>

</style>
